
<template lang="pug">
v-container.pa-1(ref="container")
  // Technique for wrapping a form field in a component https://zendev.com/2018/05/31/transparent-wrapper-components-in-vue.html
  v-textarea.pa-0.ma-0(
    :label="label",
    ref="textinput",
    @click:prepend="generate_random",
    :prepend-icon="can_randomize ? 'refresh' : ''",
    :value="internalValue",
    auto-grow,
    flat,
    hide-details,
    @input="updateValue($event)",
    v-on="listeners",
    rows="1"
    v-resize="onWindowResized"
  )
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    stub_values: {
      type: Array,
      default: function () {
        return [""];
      },
    },
    label: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      internalValue: "",
      textareaWidth: undefined,
    };
  },
  watch: {
    stub_values: function (newVal, oldVal) {
      this.generate_random();
    },
  },
  inheritAttrs: false,
  methods: {
    generate_random: function () {
      var possible_paras = this.stub_values;
      do {
        var random_para =
          possible_paras[Math.floor(Math.random() * possible_paras.length)];
      } while (this.internalValue === random_para && possible_paras.length > 1);
      this.internalValue = random_para;
      this.$emit("input", random_para);
    },
     onWindowResized: function() {
      let textareaWidth = this.$refs.container && this.$refs.container.offsetWidth;
      if (textareaWidth !== this.textareaWidth) {
        this.textareaWidth = textareaWidth;
        this.$refs.textinput.calculateInputHeight();
      }
     },
    updateValue: function (event) {
      if (event.target) {
        this.internalValue = event.target.value;
        this.$emit("input", this.internalValue);
      }
    },
  },
  mounted() {
    this.generate_random();
  },
  computed: {
    can_randomize() {
      return this.stub_values.length > 1;
    },
    computed_value() {
      return this.value;
    },
    listeners() {
      const { ...listeners } = this.$listeners;
      return listeners;
    },
  },
};
</script>

<!-- This is a bit of a hack to remove extra top padding of text areas -- this is the only way I could find that would work -->
<style lang="css" >
</style>
